import React, { useState } from 'react'
import { Grid, TextareaAutosize } from '@material-ui/core'
import CustomInput from '../CustomInput'

function PersonalInformation({ form, setForm }) {
  const { firstName, lastName, file } = form

  //console.log('STATE : ', form)

  const inputField = [
    { label: 'First Name', value: firstName, name: 'firstName' },
    { label: 'Last Name', value: lastName, name: 'lastName' },
    // { label: 'Email', value: file, name: 'image', type: 'file' },
  ]

  return (
    <Grid container style={{}} spacing={3}>
      {inputField.map((item, index) => (
        <Grid item lg={4} key={index}>
          <CustomInput label={item.label} icon={item.icon} name={item.name} value={item.value} number={item.number ? true : false} form={form} setForm={setForm} formCheck={true} type={item.type} />
        </Grid>
      ))}
    </Grid>
  )
}

export default PersonalInformation
